import { render, staticRenderFns } from "./Recetas.vue?vue&type=template&id=bb9b6062&scoped=true"
import script from "./Recetas.vue?vue&type=script&lang=js"
export * from "./Recetas.vue?vue&type=script&lang=js"
import style0 from "./Recetas.vue?vue&type=style&index=0&id=bb9b6062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9b6062",
  null
  
)

export default component.exports